


<section
class="forgot-password-section container-fluid sts-section sts-form">


<app-sts-section-header key="sts-forgot-password-via-email" [errors]="errors">
  Recover Your Password
</app-sts-section-header>

<app-sts-section-body *ngIf="notSentYet" key="sts-forgot-password-body-via-email">
  <div  class="col-24 forgot-instruction-top">
    Send yourself an email to reset your password.
  </div>
</app-sts-section-body>

<app-sts-section-body *ngIf="!notSentYet" key="sts-forgot-password-body-via-email">
  <div  class="col-24 forgot-instruction-top">
    Return to login page.
  </div>
</app-sts-section-body>


<div class="row">
  <div class="col-24">
    <button *ngIf="notSentYet" app-sts-cms-txt key="sts-cancel-button" class="sts-btn other-sts-btn" routerLink="/">
      Cancel
    </button>

    <button *ngIf="!notSentYet" app-sts-cms-txt key="sts-next-button" class="sts-btn other-sts-btn" routerLink="/">
      Next
    </button>

    <button class="sts-btn other-sts-btn" app-sts-cms-txt
            key="sts-send-questions-switch-button"
            type="button"
            *ngIf="false"
            (click)="switchToQuestions()">Answer Questions Instead
    </button>

    <app-sts-button *ngIf="notSentYet" key="sts-reset-by-email-text"
            (click)="sendRecoveryEmail()">Yes, Send Recovery Email!</app-sts-button>


  </div>
</div>


</section>
